import { render, staticRenderFns } from "./FooterInfoComponent.vue?vue&type=template&id=25b94de6"
import script from "./FooterInfoComponent.vue?vue&type=script&lang=js"
export * from "./FooterInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports